import type { Entry } from "../types";

export const reviewsMessages = {
  newReview: { ko: "새 검토 요청", en: "New Review" },
  title: { ko: "제목", en: "Title" },
  product: { ko: "상품명", en: "Product" },
  channel: { ko: "채널", en: "Channel" },
  audience: { ko: "타깃 고객", en: "Target Audience" },
  scheduledDate: { ko: "게시 예정일", en: "Scheduled Date" },
  bodyText: { ko: "광고 본문", en: "Advertising Copy" },
  file: { ko: "첨부 파일", en: "Attachment" },
  submit: { ko: "제출", en: "Submit" },
  cancel: { ko: "취소", en: "Cancel" },
  status: { ko: "상태", en: "Status" },
  risk: { ko: "리스크", en: "Risk" },
  outcomeApprovedTitle: { ko: "승인되었습니다", en: "Approved" },
  outcomeApprovedHelp: {
    ko: "컴플라이언스 담당자가 승인했습니다. 승인 문서가 준비되면 다운로드할 수 있습니다.",
    en: "A compliance officer approved this material. Download the approved document when it is ready.",
  },
  outcomeChangesTitle: { ko: "수정이 필요합니다", en: "Changes requested" },
  outcomeChangesHelp: {
    ko: "담당자가 요청한 수정 사항을 반영한 뒤 자료를 다시 제출하세요.",
    en: "Apply the officer's requested corrections, then submit revised material.",
  },
  outcomeSelfCheckRejectedTitle: { ko: "사전 검토에서 지적 사항이 발견되었습니다", en: "Pre-check found issues" },
  outcomeSelfCheckRejectedHelp: {
    ko: "지적 사항을 확인하고 자료를 수정한 뒤 다시 제출하세요. 사람의 최종 결정은 아직 내려지지 않았습니다.",
    en: "Review the issues, revise the material, and resubmit. No final human decision has been made.",
  },
  outcomeSelfCheckCompleteTitle: { ko: "사전 검토가 완료되었습니다", en: "Pre-check complete" },
  outcomeSelfCheckCompleteHelp: {
    ko: "자동 사전 검토 결과입니다. 사람의 최종 승인을 뜻하지 않습니다.",
    en: "This is an automated pre-check result, not a final human approval.",
  },
  outcomeWaitingTitle: { ko: "담당자 결정을 기다리고 있습니다", en: "Waiting for an officer's decision" },
  outcomeWaitingHelp: {
    ko: "현재 요청자가 해야 할 일은 없습니다. 담당자의 결정이 기록되면 여기에서 확인할 수 있습니다.",
    en: "There is nothing you need to do now. The officer's decision will appear here.",
  },
  outcomeOfficerTitle: { ko: "최종 결정이 필요합니다", en: "Final decision needed" },
  outcomeOfficerHelp: {
    ko: "자료와 지적 사항을 확인한 뒤 승인 또는 반려 결정을 기록하세요.",
    en: "Inspect the material and findings, then record an approval or rejection.",
  },
  outcomeAnalyzingTitle: { ko: "자료를 검토하고 있습니다", en: "Review in progress" },
  outcomeAnalyzingHelp: {
    ko: "분석이 끝나면 이 화면이 자동으로 갱신됩니다. 현재 필요한 조치는 없습니다.",
    en: "This page updates when analysis finishes. No action is needed right now.",
  },
  outcomeDraftTitle: { ko: "검토 초안", en: "Review draft" },
  outcomeDraftHelp: { ko: "검토 진행 상태를 확인하세요.", en: "Check the review progress." },
  outcomeDecidedTitle: { ko: "결정이 기록되었습니다", en: "Decision recorded" },
  outcomeDecidedHelp: {
    ko: "결정 세부 내용은 현재 표시할 수 없습니다. 담당자에게 문의해 주세요.",
    en: "The decision details are currently unavailable. Contact a compliance officer.",
  },
  outcomeResubmitAction: { ko: "수정 자료 제출", en: "Submit revised material" },
  outcomeReviewEvidenceAction: { ko: "지적 사항과 근거 보기", en: "View findings and evidence" },
  outcomeReviewWorkAction: { ko: "자료 검토하기", en: "Review material" },
  outcomeEvidenceHeading: { ko: "검토 세부 결과", en: "Review details" },
  outcomeEvidenceHelp: {
    ko: "AI 분석, 지적 사항, 적용 기준 및 수정 이력을 확인할 수 있습니다.",
    en: "See the AI analysis, findings, applied standards, and revision history.",
  },
  outcomeShowDetails: { ko: "세부 결과 보기", en: "Show review details" },
  outcomeHideDetails: { ko: "세부 결과 닫기", en: "Hide review details" },
  outcomeAiRisk: { ko: "AI 위험 신호", en: "AI risk signal" },
  overdue: { ko: "기한 초과", en: "Overdue" },
  unassigned: { ko: "미할당", en: "Unassigned" },
  requester: { ko: "요청자", en: "Requester" },
  updated: { ko: "업데이트", en: "Updated" },
  search: { ko: "제목, 상품, 캠페인 검색", en: "Search title, product, or campaign" },
  reviewSearchRequester: { ko: "검토 요청 검색", en: "Search reviews" },
  reviewsNeedsDecision: { ko: "결정 대기", en: "Needs decision" },
  reviewsAssignedToMe: { ko: "내 할당", en: "Assigned to me" },
  reviewsAll: { ko: "전체 검토", en: "All reviews" },
  clearFilters: { ko: "필터 초기화", en: "Clear filters" },
  moreFilters: { ko: "필터 더 보기", en: "More filters" },
  moreActions: { ko: "추가 작업", en: "More actions" },
  assignToMe: { ko: "내게 할당", en: "Assign to me" },
  assignment: { ko: "검토 할당", en: "Review assignment" },
  officerAction: { ko: "검토 조치", en: "Review action" },
  officerActionDecide: { ko: "직접 결정", en: "Decide myself" },
  officerActionAssign: { ko: "다른 담당자에게 할당", en: "Assign to others" },
  officerActionHelp: {
    ko: "이 검토를 직접 결정하거나, 다른 관리자에게 할당할 수 있습니다.",
    en: "Decide this review yourself, or assign it to another admin.",
  },
  officerDecideNotReady: {
    ko: "분석이 끝나고 결정 대기 상태가 되면 여기서 승인하거나 반려할 수 있습니다.",
    en: "Once analysis finishes and the review is awaiting a decision, you can approve or reject it here.",
  },
  officerDecideAlreadyRecorded: {
    ko: "이 검토는 이미 결정되었습니다.",
    en: "This review already has a decision.",
  },
  assignee: { ko: "담당자 이메일", en: "Assignee email" },
  priority: { ko: "우선순위", en: "Priority" },
  save: { ko: "저장", en: "Save" },
  findings: { ko: "지적 사항", en: "Findings" },
  findingsOverview: { ko: "전체 지적 사항 한눈에 보기", en: "All findings at a glance" },
  findingsBackToList: { ko: "목록으로", en: "Back to list" },
  issuePreview: { ko: "문제 위치 미리보기", en: "Issue location preview" },
  previewFindingSelector: { ko: "지적 사항 선택", en: "Select finding" },
  issuePreviewHelp: {
    ko: "파일을 스크롤해 확인하고 검토자가 확인한 위치를 표시하세요. 표시는 원본 파일을 변경하지 않습니다.",
    en: "Scroll through the file and mark locations verified by a reviewer. Markers never alter the source file.",
  },
  // Finding badges flag the exception, not the norm: an exact wording check is
  // a fact rather than a judgment, and a less certain finding is where to look
  // first. High confidence is nearly every finding, so it gets no badge.
  findingExactMatch: { ko: "문구 정확 대조", en: "Exact wording check" },
  findingNeedsCloserLook: { ko: "확인 필요", en: "Needs a closer look" },
  findingNeedsCloserLookHint: {
    ko: "확신도가 낮거나 근거가 명확하지 않은 지적입니다. 광고 원문과 근거를 직접 확인하세요.",
    en: "This finding is less certain or lacks a clear source. Check the material and the source yourself.",
  },
  unverifiedAiLocation: { ko: "AI 위치 미검증", en: "AI location unverified" },
  reviewerAdjustedLocation: { ko: "검토자 조정 위치", en: "Reviewer-adjusted location" },
  noMarkedLocation: { ko: "표시 위치 없음", en: "No marked location" },
  noVisualPreview: {
    ko: "이 자료에는 표시할 이미지 또는 PDF 미리보기가 없습니다.",
    en: "This material has no image or PDF preview to annotate.",
  },
  previewZoom: { ko: "미리보기 확대/축소", en: "Preview zoom" },
  previewLoading: { ko: "미리보기를 불러오는 중…", en: "Loading preview…" },
  pdfScrollStatus: {
    ko: "스크롤 탐색 ,  {page} / {count} 페이지",
    en: "Scroll to browse ,  page {page} of {count}",
  },
  drawMarkedLocationHelp: {
    ko: "빈 곳을 드래그하면 {number}번 지적 사항에 영역이 추가되고 자동 저장됩니다(최대 20개, 여러 페이지 가능). 영역을 끌어 이동하고, 오른쪽 아래 손잡이로 크기를 조정하고, ×로 삭제하세요. 점선 제안을 누르면 추가됩니다.",
    en: "Drag on empty space to add a box to finding {number}; changes save automatically (up to 20, on any page). Drag a box to move it, resize it with the bottom-right handle, or remove it with ×. Click a dashed suggestion to add it.",
  },
  locationSaving: { ko: "위치 저장 중…", en: "Saving location…" },
  locationSaved: { ko: "위치 자동 저장됨", en: "Location saved automatically" },
  locationSaveFailed: { ko: "위치 저장 실패", en: "Location save failed" },
  drawTarget: { ko: "{number}번 {title}", en: "Finding {number}: {title}" },
  drawHint: {
    ko: "미리보기를 드래그해 영역을 추가하세요. 자동 저장됩니다.",
    en: "Drag on the preview to add a box. Changes save automatically.",
  },
  addLocation: { ko: "+ 영역 추가", en: "+ Add box" },
  showInPreview: { ko: "미리보기에서 보기", en: "Show in preview" },
  previewLocation: { ko: "미리보기 위치", en: "Preview location" },
  markedLocationCount: { ko: "표시 영역 {count}개", en: "{count} box(es)" },
  removeMarkedLocation: { ko: "선택한 영역 삭제", en: "Delete selected box" },
  suggestedLocation: { ko: "제안 위치", en: "Suggested location" },
  suggestedLocationFound: { ko: "파일 문구 일치", en: "Text match in file" },
  suggestedLocationsHelp: {
    ko: "점선은 근거 문구가 파일에서 발견된 위치입니다. 확인한 뒤 적용하세요.",
    en: "Dashed boxes show where the evidence text appears in the file. Check them, then apply.",
  },
  applySuggestedLocations: { ko: "제안 위치 적용 ({count})", en: "Apply suggestions ({count})" },
  detectTextLocations: { ko: "파일에서 근거 찾기", en: "Find evidence in file" },
  detectTextLocationsDone: {
    ko: "근거 문구가 파일에서 발견된 지적 사항 {count}건",
    en: "Evidence text found in the file for {count} finding(s)",
  },
  hideMarkedLocation: { ko: "표시 숨기기", en: "Hide marker" },
  resetToAiLocation: { ko: "검토자 위치 초기화", en: "Clear reviewer location" },
  includeInCorrections: { ko: "조건부 승인 수정 요청에 포함", en: "Include in conditional-approval corrections" },
  selectedCorrectionsCount: {
    ko: "선택한 지적 사항 {count}건",
    en: "{count} selected finding(s)",
  },
  prefillCorrections: { ko: "선택 항목으로 채우기", en: "Add selected findings" },
  findingReviewerOpinion: { ko: "검토자 의견", en: "Reviewer Opinion" },
  saveReviewerOpinion: { ko: "의견 저장", en: "Save opinion" },
  findingDispositionConfirmedOption: { ko: "지적사항 인정", en: "Finding confirmed" },
  severity: { ko: "심각도", en: "Severity" },
  confidence: { ko: "신뢰도", en: "Confidence" },
  evidence: { ko: "증거", en: "Evidence" },
  page: { ko: "페이지", en: "Page" },
  preview: { ko: "미리보기", en: "preview" },
  reviewerNote: { ko: "검토자 메모", en: "Reviewer note" },
  reviewerNotePlaceholder: {
    ko: "이 지적 사항에 대한 메모를 남기세요 (제출자에게 참고용으로 표시됩니다).",
    en: "Leave a note about this finding for the submitter to reference.",
  },
  suggestion: { ko: "권고 수정안", en: "Suggested Revision" },
  citation: { ko: "근거", en: "Citation" },
  method: { ko: "탐지", en: "Detection" },
  decision: { ko: "결정", en: "Decision" },
  approve: { ko: "승인", en: "Approve" },
  approveWithChanges: { ko: "조건부 승인", en: "Approve with Changes" },
  reject: { ko: "반려", en: "Reject" },
  comment: { ko: "코멘트", en: "Comment" },
  requiredCorrections: { ko: "필수 수정 요청", en: "Required Corrections" },
  recordDecision: { ko: "결정 기록", en: "Record Decision" },
  decisionActionsHelp: {
    ko: "코멘트나 수정 요청을 적은 뒤, 아래 버튼으로 결정을 기록합니다. 조건부 승인과 반려는 필수 수정 요청이 필요합니다.",
    en: "Add a comment or required corrections, then click a button to record the decision. Conditional approval and rejection need required corrections.",
  },
  resubmit: { ko: "재제출", en: "Resubmit" },
  downloadReport: { ko: "보고서 다운로드", en: "Download Report" },
  downloadApprovedDocument: {
    ko: "승인 문서 다운로드",
    en: "Download Approved Document",
  },
  downloadApprovedDocumentHint: {
    ko: "원본 파일 마지막에 승인 페이지가 추가된 문서입니다.",
    en: "The original file with the approval page appended.",
  },
  aiSummary: { ko: "AI 검토 결과", en: "AI Review Result" },
  disclaimer: {
    ko: "AI 분석은 법적 판정이 아닙니다. 최종 승인 여부는 사람의 결정에 따릅니다.",
    en: "AI analysis is not a legal determination. Final approval rests on the human decision.",
  },
  aiPending: {
    ko: "분석이 아직 완료되지 않았습니다. 완료되면 이 화면이 자동으로 갱신됩니다.",
    en: "The analysis has not finished yet. This page refreshes automatically when it does.",
  },
  materialOverview: { ko: "AI가 파악한 자료 내용", en: "What the AI read" },
  recommendedAction: { ko: "권고 조치", en: "Recommended action" },
  reviewChecklist: { ko: "기준별 확인 결과", en: "Checked against" },
  reviewChecklistHelp: {
    ko: "적용된 각 기준에 대해 AI가 어떻게 판단했는지 보여줍니다.",
    en: "How the AI judged each applied standard.",
  },
  checklistEmpty: {
    ko: "기준별 확인 결과가 기록되지 않았습니다.",
    en: "No per-standard results were recorded.",
  },
  baselineOnlyNotice: {
    ko: "이 조직에는 승인된 정책 문서나 활성 규칙이 없어 기본 참고 기준만 적용되었습니다. 결과는 참고용이며 담당자 확인이 필요합니다.",
    en: "No approved policy or active rule exists for this organization, so only baseline references were applied. Treat the result as advisory and have an officer confirm it.",
  },
  baselineOnlyAdminHint: {
    ko: "관리자: 정책 문서를 업로드하고 규칙을 활성화하면 검토 정확도가 크게 올라갑니다.",
    en: "Administrators: upload policy documents and activate rules to improve accuracy substantially.",
  },
  degradedResultNotice: {
    ko: "근거 요건을 충족하지 못해 폐기된 지적이 {count}건 있습니다. 아래 결과는 완전하지 않을 수 있으므로 담당자 검토가 필요합니다.",
    en: "{count} finding(s) were discarded for failing the evidence requirement. The result below may be incomplete and needs officer review.",
  },
  uncitedFindingNotice: {
    ko: "등록된 정책과 규칙에 해당하지 않는 참고 사항입니다. 담당자 확인이 필요합니다.",
    en: "Advisory only: this does not map to a registered policy or rule. An officer should confirm it.",
  },
  technicalDetails: { ko: "기술 세부정보", en: "Technical details" },
  sourcesApplied: {
    ko: "적용된 기준 {total}건 (사내 승인 {approved}건)",
    en: "{total} standards applied ({approved} internally approved)",
  },
} as const satisfies Record<string, Entry>;
